import React from 'react';
import Icon from '@/v2/components/atoms/Icon';

import './Calendar.scss';

const Calendar = (props) => (
    <Icon iconName="Calendar" {...props}>
        <svg viewBox="0 0 11 10.5" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" {...props}>
            <path
                stroke={0}
                // eslint-disable-next-line
                d="M9.5 11h-8A1.5 1.5 0 010 9.5v-6A1.5 1.5 0 011.5 2h8A1.5 1.5 0 0111 3.5v6A1.5 1.5 0 019.5 11zm-8-8a.5.5 0 00-.5.5v6a.5.5 0 00.5.5h8a.5.5 0 00.5-.5v-6a.5.5 0 00-.5-.5z"
                transform="translate(0 -.5)"
            />
            <path
                stroke={0}
                d="M3 3.5a.5.5 0 01-.5-.5V1a.5.5 0 011 0v2a.5.5 0 01-.5.5zM8 3.5a.5.5 0 01-.5-.5V1a.5.5 0 011 0v2a.5.5 0 01-.5.5z"
                transform="translate(0 -.5)"
            />
            <path stroke={0} d="M0 4h11v1H0z" />
        </svg>
    </Icon>
);

export default Calendar;
